import React, { FC, ReactNode } from 'react'
import { Wrapper, Title, SubTitle, Free } from './styled'

interface ComponentProps {
	children: ReactNode
	title: string
	subTitle: string
	isFree?: boolean
	className?: string
}

export const CardElement: FC<ComponentProps> = ({
	title,
	subTitle,
	children,
	isFree = false,
	className,
}) => (
	<Wrapper className={className}>
		{children}
		<Title>{title}</Title>
		<SubTitle>{subTitle}</SubTitle>
		{isFree ? <Free>Бесплатно</Free> : null}
	</Wrapper>
)
